<template>
  <div
    v-if="inventoryService.state.isOpen && !inventoryService.isLooting()"
    class="inventory-overlay"
    @click="closeInventory"
  >
    <InventoryPanel
      v-if="targetEntityId !== undefined"
      :entity-id="targetEntityId"
      :inventory-service="inventoryService"
      :asset-manager="assetManager"
      :services="services"
      :show-close="true"
      :readonly="isReadOnly"
      @click.stop
      @close="closeInventory"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';

import { AssetManager } from '../AssetManager';
import { ClientServiceContainer } from '../services/ClientServiceContainer';
import { InventoryUIService } from '../services/InventoryUIService';
import InventoryPanel from './InventoryPanel.vue';

const props = defineProps<{
  inventoryService: InventoryUIService;
  assetManager: AssetManager;
  services: ClientServiceContainer;
}>();

const targetEntityId = computed(() => props.inventoryService.getTargetEntityId());
const isReadOnly = computed(() => props.inventoryService.isReadOnly());

function closeInventory() {
  props.inventoryService.close();
}

function handleKeydown(event: KeyboardEvent) {
  if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
    return;
  }

  if (event.code === 'KeyI') {
    props.inventoryService.toggle();
  } else if (event.code === 'Escape' && props.inventoryService.state.isOpen) {
    props.inventoryService.close();
    event.stopPropagation();
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});
</script>

<style scoped>
.inventory-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  pointer-events: auto;
  padding-left: 100px; /* Offset to keep player visible */
}
</style>
